import React, { useState, useEffect, useMemo } from 'react';
import { Box, List, ListItem, ListItemText, Typography, IconButton, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, OutlinedInput, Chip, useTheme, Grid } from '@mui/material';
import { Close } from '@mui/icons-material';
import useStyles from '../../../../../styles/global-mui.js';
import { useFetch } from '../../../../../filters/useFetch.js';
import { fetchCompetitions, fetchTeams } from '../../../../../api/index.js';
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../../../../constants/actionTypes.js';
import DatePicker_Dsas from '../../../../../dsasComponents/DatePicker_Dsas.js';
import { discipline_all, getActualSeason, season_all } from '../../../../../bdd/bddSTUB.js';
import DsasButton from '../../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowLeft, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Step2 = ({ state, onSubmit, onBack}) => {

    // La step 2 doit charger les données necessaires, c a dire : 
    // Competitions
    const [filters] = useState({provider : state.provider})
    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)


  const [competitionDetails, setCDetails] = useState(state.competitionDetails);

  const [matchsDetails, setMatchsDetails] = useState(state.matchsDetails)

  

  // useEffect(() => {
  //   const matchs = matchsDetails.map(m => m.idMatch)

  //     // On met en ordre les compétitions
  //     const {competitionOrder = []} = state

  //     let newOrder = competitionOrder

  //     if(competitionDetails){
  //       competitionDetails.forEach(c => {
  //         if(c.competition && !newOrder.includes(c.competition)){
  //           newOrder.push(c.competition)
  //         }
  //       })
  //     }

  //   onSubmit({competitionDetails, matchsDetails, matchs, competitionOrder : newOrder});

  // }, [competitionDetails, matchsDetails])

      useEffect(() => {
      const matchs = matchsDetails.map(m => m.idMatch)

      const newOrder = [
        ...(state.competitionOrder || []),
        ...competitionDetails
          .map(c => c.competition)
          .filter(c => c && !(state.competitionOrder || []).includes(c))
      ]

      onSubmit({
        competitionDetails,
        matchsDetails,
        matchs,
        competitionOrder: newOrder
      });
    }, [competitionDetails, matchsDetails])

  const handleAddCDetail = () => {

    let newCDetail = competitionDetails.length >= 1 ? 
                              {...competitionDetails[competitionDetails.length-1], competition : '', teams : []} 
                                : 
                              {competition : '', teams : [], startDate : Date.now(), endDate : Date.now(), createLivePerMatch : true, homeMatches : true, awayMatches : true }

    setCDetails((s) => [...s, newCDetail]);
  };

  const handleChangeCDetail = (e, idx) => {
    if(!competitionDetails[idx])
      return


    const newCDetails = competitionDetails.map((c, i) => {
      if(i === idx)
        return {...c, [e.target.name] : e.target.value}
      
      return c
    })

    setCDetails(newCDetails)
  }

  const handleRemoveCDetail = (index)  => {
    setCDetails((s) => s.filter((_, i) => i !== index));
  };

  const handleBack = (event) => {
    event.preventDefault();
    onBack();
  };

  const isFormError = () => {
    return false
  }

  return (
    <Box>

      {/* Live name */}
      <Box className='padding-wrapper'>
        <Typography variant='caption'>Nom du direct</Typography>
        <Typography variant='h2' sx={{padding:0}}>{state.name}</Typography>
      </Box>

      <Box className='large-separator'></Box>

      {
        matchsDetails && matchsDetails.length>0 && <Box className='medium-wrapper'>
          {JSON.stringify(matchsDetails)}
          <MatchsDetails matchsDetails={matchsDetails} setMatchsDetails={setMatchsDetails}/>
        </Box>

      }


      <Box className='padding-wrapper' sx={{ display: "flex", flexDirection: "column" }}>
        {competitionDetails.map((cDetail, index) => (
          <>
          <Box key={index}>

            <Box sx={{display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'flex-start',
              alignItems: 'center'}}
              >
              <Typography variant="h2" sx={{padding:'10px', textTransform: 'uppercase'}}>Competition {index + 1}
              </Typography>
               <FontAwesomeIcon icon={faTrash}
                  className='icon-button'
                  onClick={() => handleRemoveCDetail(index)}
                  >
                  </FontAwesomeIcon>
            </Box>
            
            <Box className='small-padding'>
              <CompetitionDetail idx={index} cDetail={cDetail} competitions={competitions} onChange={handleChangeCDetail}/>
            </Box> 
          </Box>
          <Box className='medium-padding'></Box>
          <Box className='large-separator'></Box>
          <Box className='small-padding'></Box>
          </>
        ))}
        <Box className='centered-medium-wrapper'>
          <DsasButton icon={faPlus} label="Ajouter une competition" onClick={handleAddCDetail} variant = 'secondary'/>
        </Box>
      </Box>
      <Box className='small-padding display-grid'>
                    <DsasButton 
                      onClick={handleBack}
                      icon={faArrowLeft}
                      label="Etape précédente" 
                      variant = 'alternative' 
                      customCss={{width: '190px',
                        justifySelf: 'left',
                        display: 'flex',
                        flexDirection: 'rowe',
                        flexWrap: 'nowrap',
                        alignContent: 'flex-start',
                        justifyContent: 'space-evenly',
                        alignItems: 'center'}}
                    />
                 </Box>
    </Box>
  );

}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const MatchsDetails = React.memo(({ matchsDetails,  setMatchsDetails }) => {
    const compareByDay = (matchA, matchB) => matchA.day - matchB.day;
  
    const groupedMatches = useMemo(() => {

      const result =  matchsDetails.reduce((acc, match) => {
        const competitionName = match.competition.name;
        if (!acc[competitionName]) {
          acc[competitionName] = [];
        }
        acc[competitionName].push(match);
        return acc;
      }, {});

      for (const competitionMatches of Object.values(result)) {
        competitionMatches.sort(compareByDay);
      }

      return result

    }, [matchsDetails])

    const removeMatch = (idMatch) => {
      setMatchsDetails(s => s.filter(m => m.idMatch !== idMatch))
    }

    const removeMatchs = (matchsToDelete) => {
      setMatchsDetails(s => s.filter(m => !matchsToDelete.find(i => i.idMatch === m.idMatch)))
    }
  
    
  
    return (
      <Box>
        {Object.entries(groupedMatches).map(([competitionName, competitionMatches]) => (
          <Box key={competitionName}>
            <Box sx={{display : 'flex', flexDirection : 'row'}}>
              <h2>{competitionName}</h2>
              <IconButton aria-label="Delete" size="small" onClick={() => removeMatchs(competitionMatches)}><Close /></IconButton>
            </Box>
            
          <Box maxHeight="200px" overflow="auto">
            <List>
              {competitionMatches.map((match, idx) => (
                <ListItem key={match.idMatch} sx={{p : 0, pl : 1, backgroundColor : idx % 2 === 0 ? 'white' : 'lightgrey'}}>
                  <ListItemText primary={`[${match.day}] ${match.homeTeam.name} - ${match.awayTeam.name}`} />
                  <IconButton aria-label="Delete" size="small" onClick={() => removeMatch(match.idMatch)}>
                    <Close />
                  </IconButton>
                </ListItem>
              ))}
            </List>
          </Box>
          </Box>
        ))}
      </Box>
    );
  }, (prevProps, nextProps) => {
    return prevProps.matchsDetails && nextProps.matchsDetails && prevProps.matchsDetails.length === nextProps.matchsDetails.length;
  });

const CompetitionDetail = ({idx, cDetail, competitions, provider, onChange}) => {
    const theme = useTheme();

    const classes = useStyles();

    // Permet de filtrer les competitions par discipline

    // Charger les équipes de la compétition selectionnée
    const filters = useMemo(() => {
        return {provider, competition : cDetail.competition}

    }, [cDetail.competition, provider])

    const [teams, loadingTeam] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)


    const [discipline, setDiscipline] = useState('')
    const [season, setSeason] = useState(getActualSeason())

    const competitionsFiltered = useMemo(() => {

      return competitions.filter(c => (!discipline || c.discipline === discipline) && (!season || c.season === season))

    }, [competitions, discipline, season])

    useEffect(() => {
      onChange({target : {name : 'competition', value : ''}}, idx)

    }, [discipline])

    useEffect(() => {
      unselectAllTeam()

    }, [cDetail.competition])

    useEffect(() => {
      selectAllTeam()

    }, [teams])

    const selectAllTeam = () => {
      if(teams && teams.length){
        const selectedTeams = teams.map(t => t._id)

        onChange({target : { name : 'teams', value : selectedTeams}}, idx)
      }
    }

    const unselectAllTeam = () => {
        onChange({target : { name : 'teams', value : []}}, idx)
    }

    const getTeamLabel = (value) => {
      const team = teams.find(t => t._id === value)

      if(team)
        return team.name
    }

    return (
        <Box>
            { /* competition */ }
            <Grid container spacing={1.5}>
                <Grid item xs={12} sm={3} md={3}>
                  <FormControl fullWidth className={classes.customInput}>
                        <InputLabel id={`discipline-${idx}`}>
                            {`Discipline`}
                        </InputLabel>
                        <Select
                            labelId={`discipline-${idx}`}
                            id={`discipline-${idx}`}
                            value={discipline}
                            name = 'discipline'
                            label={`Discipline`}
                            placeholder={`Discipline`}
                            onChange={(e) => {
                                setDiscipline(e.target.value)
                            }}
                        >
                            {discipline_all.map((c) => (
                            <MenuItem className={classes.customListItem} key={c._id} value={c._id}>
                                {c.name}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} md={3}>
                <FormControl fullWidth className={classes.customInput}>
                    <InputLabel id={`season-${idx}`}>
                        {`Saison`}
                    </InputLabel>
                    <Select
                        labelId={`season-${idx}`}
                        id={`season-${idx}`}
                        value={season}
                        name = 'season'
                        label={`Saison`}
                        placeholder={`Saison`}
                        onChange={(e) => {
                            setSeason(e.target.value)
                        }}
                    >
                        {season_all.map((c) => (
                        <MenuItem className={classes.customListItem} key={c._id} value={c._id}>
                            {c.name}
                        </MenuItem>
                        ))}
                    </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth className={classes.customInput} error={!cDetail.competition}>
                    <InputLabel id={`competition-${idx}`}>
                        {`Competition`}
                    </InputLabel>
                    <Select
                        labelId={`competition-${idx}`}
                        id={`competition-${idx}`}
                        value={cDetail.competition}
                        name = 'competition'
                        label={`Compétition`}
                        placeholder={`Compétition`}
                        onChange={(e) => {
                            onChange(e, idx)
                        }}
                    >
                        {competitionsFiltered.map((c) => (
                        <MenuItem className={classes.customListItem} key={c._id} value={c._id}>
                            {c.name}
                        </MenuItem>
                        ))}
                    </Select>
                </FormControl>
              </Grid>
            </Grid>

            
            { /* teams */ }
            {cDetail.competition && <>
            <Box className='small-padding'></Box>
            <Box>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth sx={{mt : 1}} error={!teams || !teams.length}>
                    <InputLabel id={`teams-${idx}`}>Equipes</InputLabel>
                    <Select
                    labelId={`teams-${idx}`}
                    id={`teams-${idx}`}
                    multiple
                    value={cDetail.teams}
                    onChange={(event) => {
                        const {
                        target: { value },
                        } = event;
                        onChange({target : {name : 'teams', value : typeof value === 'string' ? value.split(',') : value}}, idx)
                    }}
                    input={<OutlinedInput id="select-multiple-chip" label="Joueurs" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value} label={getTeamLabel(value)} />
                        ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                    >
                    {teams.map(team => (
                        <MenuItem
                        key={team._id}
                        value={team._id}
                        style={getStyles(team._id, teams, theme)}
                        className={classes.customListItem}
                        >
                        {team.name}
                        </MenuItem>
                    ))}
                    </Select>
                  </FormControl>
                </Grid>
            </Grid>
             <Grid container spacing={1.5}>
                <Grid item xs={12} sm={12} md={12}>
                  <Box sx={{
                        marginTop: '5px',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        alignContent: 'center',
                        flexWrap: 'nowrap',
                        flexDirection: 'row'}}>
                    <DsasButton label="Tout selectionner" onClick={() => selectAllTeam()} variant = 'alternative' focused={false} customCss={{width:'175px'}}/>
                    <DsasButton label="Tout déselectionner" onClick={() => unselectAllTeam()} variant = 'alternative' focused={false} customCss={{width:'195px', marginLeft: '5px'}}/>
                  </Box>
                </Grid>
              </Grid>
            

            { /* date */ }
              <Box sx={{mt : 3}}>
                <Box sx={{display : 'flex', flexDirection : 'row'}}>
                  <DatePicker_Dsas name="startDate" value={cDetail.startDate} label={"Date de début"} onChange={(e) => onChange({target : {name : 'startDate', value : e}}, idx)}/>

                  <DatePicker_Dsas name="endDate" value={cDetail.endDate} label={"Date de fin"} onChange={(e) => onChange({target : {name : 'endDate', value : e.setHours(e.getHours() + 24)}}, idx)}/>
                </Box>
              </Box>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={cDetail.homeMatches}
                    onChange={(e) => onChange({target : {name : e.target.name, value : e.target.checked}}, idx)}
                    name="homeMatches"
                    color="primary"
                  />
                }
                label="Matchs à domicile"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={cDetail.awayMatches}
                    onChange={(e) => onChange({target : {name : e.target.name, value : e.target.checked}}, idx)}
                    name="awayMatches"
                    color="primary"
                  />
                }
                label="Matchs à l'extérieur"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={cDetail.createLivePerMatch}
                    onChange={(e) => onChange({target : {name : e.target.name, value : e.target.checked}}, idx)}
                    name="createLivePerMatch"
                    color="primary"
                  />
                }
                label="Créer un live par match"
              />

            </Box>
            </>
            }


        </Box>
        
    )
}

export default Step2